import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.some";
import _isString from "lodash/isString";
import _isNil from "lodash/isNil";
import _endsWith from "lodash/endsWith";
import numeral from 'numeral'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

var parseNumeral = function parseNumeral(rawValue) {
  return numeral(_isString(rawValue) && !_endsWith(rawValue, '%') ? "".concat(rawValue, "%") : rawValue);
};

var isNumber = function isNumber(key) {
  return /\d/.test(key);
};

var isControlKey = function isControlKey(key) {
  return key === 'Enter';
};

var KEYS_ALLOWED_ONCE = ['.', '%'];
export var isKeyAllowed = function isKeyAllowed(_ref) {
  var value = _ref.target.value,
      key = _ref.key;

  // numbers are allowed
  if (isNumber(key)) {
    return true;
  } // decimal is allowed only once


  if (KEYS_ALLOWED_ONCE.some(function (candidateKey) {
    return candidateKey === key && value.indexOf(candidateKey) === -1;
  })) {
    return true;
  }

  if (isControlKey(key)) {
    return true;
  }

  return false;
};
export var hasNoValue = function hasNoValue(rawValue) {
  return rawValue === '' || _isNil(rawValue);
};
export var formatValue = function formatValue(rawValue, formatMask) {
  return parseNumeral(rawValue).format(formatMask);
};
export var formatEvent = function formatEvent(value) {
  return {
    target: {
      value: hasNoValue(value) ? '' : value
    }
  };
};
export var getUpdatedState = function getUpdatedState(rawValue) {
  var formatMask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (hasNoValue(rawValue)) {
    return {
      formattedValue: '',
      rawValue: ''
    };
  }

  var numValue = parseNumeral(rawValue);
  return {
    rawValue: rawValue,
    value: numValue.value(),
    formattedValue: formatMask ? formatValue(rawValue, formatMask) : rawValue
  };
};